import React from "react";
import PropTypes from "prop-types";

import Section from "../common/Section";
import Form from "../common/Form";

import PlannenForm from "./parts/PlannenForm";
import BehoefteForm from "./parts/BehoefteForm";
import EenCampusmodelForm from "./parts/EenCampusmodelForm";
import KwaliteitsontwikkelingEnInnovatieForm from "./parts/KwaliteitsontwikkelingEnInnovatieForm";
import PrioritaireBeschikkingForm from "./parts/PrioritaireBeschikkingForm";

const BeoordelingscriteriaTopsportForm = (props) => {
	const {
		beoordelingscriteria,
		disabled,
		errors,
		validationMessageType,
		onChange,
		documenten,
		onDropFiles,
		onDeleteFile,
		onSave,
		color,
		fileTypes,
		fileSessionStarted,
		voorbeeldInplantingsplanURL
	} = props;


	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}

	function getFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			return documenten.find(x => x.name === component).files;
		} else return [];
	}

	const sharedProps = {
		beoordelingscriteria,
		disabled,
		errors,
		validationMessageType,
		color,
		onChange,
		documenten,
		mapDeleteFile,
		mapDropFiles,
		getFilesForDossierComponent,
		fileTypes
	};
	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={color}>
			<Form
				title={"Invulformulier beoordelingscriteria"}
				name="beoordelingscriteria"
				rightButtonLabel="Bewaar"
				rightButtonDisabled={disabled}
				onRightButtonClick={onSave}>
				<PlannenForm
					{...sharedProps}
					voorbeeldInplantingsplanURL={voorbeeldInplantingsplanURL}
					fileSessionStarted={fileSessionStarted}
				/>
				<BehoefteForm
					{...sharedProps}
					fileSessionStarted={fileSessionStarted}
				/>
				<PrioritaireBeschikkingForm
					{...sharedProps}
				/>
				<EenCampusmodelForm
					{...sharedProps}
				/>
				<KwaliteitsontwikkelingEnInnovatieForm
					{...sharedProps}
				/>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
BeoordelingscriteriaTopsportForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	fileTypes: PropTypes.object,
	fileSessionStarted: PropTypes.bool,
	voorbeeldInplantingsplanURL: PropTypes.string

};

export default BeoordelingscriteriaTopsportForm;